import AlertTriangleSvg from "@redotech/redo-icons/alert-triangle.svg";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";

export interface DeleteSupportTicketConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteSupportTicketConfirmModal = memo(
  function DeleteSupportTicketConfirmModal({
    open,
    onClose,
    onConfirm,
  }: DeleteSupportTicketConfirmModalProps) {
    return (
      <RedoModal
        isOpen={open}
        modalSize="sm"
        onModalCloseRequested={onClose}
        primaryButton={{ text: "Delete", onClick: onConfirm, size: "md" }}
        secondaryButton={{ text: "Cancel", onClick: onClose, size: "md" }}
        subtitle="Are you sure you want to delete this ticket? This action cannot be undone."
        theme="error"
        title="Delete ticket"
        TitleIcon={AlertTriangleSvg}
      />
    );
  },
);
